import { DeleteForever } from "@mui/icons-material";
import {
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import { removeCrush } from "../redux/actions/crushActions";
import URL from "../redux/api";

const MatchUpPage = () => {
  const { user } = useSelector((state) => state.Auth);
  const { profile } = useSelector((state) => state.ProfileDetails);
  const [matches, setMatches] = useState([]);

  useEffect(() => {
    async function checl() {
      const { data } = await axios.put(
        URL + "/crushes/check-matches",
        {},
        {
          headers: {
            authorization: "Bearer " + user?.token,
          },
        }
      );
      console.log(data);
      setMatches(data.matches);
    }

    checl();
  }, []);
  console.log({ profile });
  const dispatch = useDispatch();
  return (
    <div className="bg-pink-50 min-h-screen px-5">
      <Header />

      {/* check matches */}
      <IconButton></IconButton>
      {/* matches */}

      {/* crushes */}
      <Paper>
        <h2 className="pl-5 text-2xl capitalize pt-4">my crushes</h2>

        {!profile.crushOnThem?.length && (
          <p className="pl-5 text-gray-400 capitalize pt-4">add crushes</p>
        )}
        <List>
          {profile?.crushOnThem?.map((x) => (
            <ListItem key={x._id} button>
              <ListItemAvatar>
                <Avatar src={`${URL}/${x.profileImage}`} />
              </ListItemAvatar>
              <ListItemText primary={`${x.firstName}`} />
              <ListItemSecondaryAction>
                <IconButton
                  color="error"
                  onClick={() => dispatch(removeCrush(x._id))}>
                  <DeleteForever />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Paper>

      <Paper className="mt-10">
        <h2 className="pl-5 text-2xl capitalize pt-4">my matches</h2>
        <List>
          {!matches.length && (
            <p className="pl-5 text-gray-400 capitalize pt-4">no matches yet</p>
          )}
          {matches?.map((x) => (
            <ListItem key={x._id} button>
              <ListItemAvatar>
                <Avatar src={`${URL}/${x.profileImage}`} />
              </ListItemAvatar>
              <ListItemText primary={`${x.firstName}`} />
              <ListItemSecondaryAction>
                <IconButton
                  color="error"
                  onClick={() => dispatch(removeCrush(x._id))}>
                  <DeleteForever />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Paper>
    </div>
  );
};

export default MatchUpPage;
